// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","menuEntry":"menuEntry_menuEntry__Mrcl_"};